module.exports = __webpack_public_path__ + "img/mouse-globe.ec467204.svg";